module.exports = __webpack_public_path__ + "static/media/Lew_W.ee28674a.jpg";